import { createQueue } from '@/shared/config/bullmq.config.js';

export const NotificationQueue = createQueue('notification');

export enum NotificationJobType {
  SEND_EMAIL = 'send_email',
  SEND_SMS = 'send_sms',
  PLAN_STATUS_EMAIL = 'plan_status_email',
}
